import React from 'react';
import { Button, Checkbox, Drawer } from 'antd';
import { HolderOutlined } from '@ant-design/icons';

const TableColumnDrawer = ({
  open,
  columnConfig,
  onClose,
  onReset,
  onSave,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
  onVisibilityChange,
}) => (
  <Drawer
    title="Table Columns"
    placement="right"
    width={420}
    zIndex={2100}
    open={open}
    onClose={onClose}
    destroyOnClose={false}
    footer={(
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
        <Button onClick={onReset}>
          Reset
        </Button>
        <div style={{ display: 'flex', gap: 12 }}>
          <Button onClick={onClose}>
            Cancel
          </Button>
          <Button type="primary" onClick={onSave}>
            Save
          </Button>
        </div>
      </div>
    )}
  >
    <div style={{ color: '#8c8c8c', marginBottom: 12 }}>
      Drag to reorder columns. Uncheck items to hide them from the table.
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {columnConfig.map((item) => (
        <div
          key={item.key}
          draggable={!item.locked}
          onDragStart={() => onDragStart(item.key)}
          onDragOver={onDragOver}
          onDrop={() => onDrop(item.key)}
          onDragEnd={onDragEnd}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '10px 12px',
            border: '1px solid #f0f0f0',
            borderRadius: 8,
            background: item.locked ? '#fafafa' : '#fff',
            cursor: item.locked ? 'not-allowed' : 'move',
            opacity: item.locked ? 0.8 : 1,
          }}
        >
          <HolderOutlined style={{ color: item.locked ? '#d9d9d9' : '#bfbfbf', fontSize: 16 }} />
          <Checkbox
            checked={item.visible}
            disabled={item.locked}
            onChange={(event) => onVisibilityChange(item.key, event.target.checked)}
          />
          <div style={{ minWidth: 0, flex: 1 }}>
            <div style={{ fontWeight: 500, color: '#262626' }}>{item.title}</div>
            <div style={{ fontSize: 12, color: '#8c8c8c' }}>{item.key}</div>
          </div>
        </div>
      ))}
    </div>
  </Drawer>
);

export default TableColumnDrawer;
